import { createAction } from 'redux-act';

export const addMessage = createAction('Add agent message', ({ id, timestamp, text, link }) => ({ message: { id, timestamp, text, link } }));
export const removeMessage = createAction('Remove agent message', (id) => ({ id }));